import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const NAV_LINKS = [
  { to: "/about", label: "About" },
  { to: "/dog-walking", label: "Dog Walking" },
  { to: "/pet-sitting", label: "Pet Sitting" },
  { to: "/home-visits", label: "Home Visits" },
  { to: "/meet-the-gang", label: "Meet the Gang" },
  { to: "/reviews", label: "Reviews" },
  { to: "/prices", label: "Prices" },
  { to: "/faqs", label: "FAQs" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
    <header className="sticky top-0 z-50 bg-[#F7F4ED]/90 backdrop-blur-xl border-b border-[#DDD7CB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex flex-col leading-none" data-testid="brand-wordmark">
            <span className="font-serif text-2xl sm:text-[1.7rem] font-semibold tracking-tight text-[#3F4A38]">
              Mary Pawpins
            </span>
            <span className="text-[0.6rem] uppercase tracking-[0.28em] text-[#575953] mt-1">
              Countryside Pet Care · Inverness
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7" data-testid="desktop-nav">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-[0.8rem] font-medium tracking-wide text-[#575953] hover:text-[#3F4A38] transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              data-testid="enquire-header-button"
              className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#3F4A38] text-[#F7F4ED] px-5 py-2.5 text-sm font-semibold hover:bg-[#2F382B] transition-colors"
            >
              Enquire About Availability
              <ArrowRight className="w-4 h-4" />
            </Link>
            <button
              className="lg:hidden p-2 text-[#3F4A38]"
              onClick={() => setOpen(true)}
              aria-label="Open menu"
              data-testid="mobile-menu-button"
            >
              <Menu className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

    </header>

    {open && (
        <div className="fixed inset-0 z-[60] bg-[#F7F4ED] flex flex-col" data-testid="mobile-menu">
          <div className="flex items-center justify-between h-20 px-4 sm:px-6 border-b border-[#DDD7CB]">
            <span className="font-serif text-2xl font-semibold text-[#3F4A38]">Mary Pawpins</span>
            <button onClick={() => setOpen(false)} aria-label="Close menu" className="p-2 text-[#3F4A38]" data-testid="mobile-menu-close">
              <X className="w-6 h-6" />
            </button>
          </div>
          <nav className="flex flex-col gap-1 px-6 py-8 overflow-y-auto">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="font-serif text-3xl text-[#292A26] py-3 border-b border-[#E7E2D8] hover:text-[#3F4A38] transition-colors"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="enquire-mobile-button"
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-[#3F4A38] text-[#F7F4ED] px-6 py-4 text-base font-semibold"
            >
              Enquire About Availability
              <ArrowRight className="w-4 h-4" />
            </Link>
          </nav>
        </div>
      )}
    </>
  );
};
